import auth from "./api";

const factoryApi = {
    index: async () => {
        return await auth.get("factory/all")
        .then((response) => {
            return response.data;
        }).catch((error) => {
            console.log(error.response.data.message);
            return [];
        });
    },
    
}
export default factoryApi;